import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { t } from "@/lib/translations";
import { resolveImg } from "@/lib/api";

export const Footer = ({ content }) => {
  const { lang } = useLang();
  return (
    <footer className="relative z-10 bg-[#0A0A0A] border-t border-white/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div>
            <div className="flex items-center gap-3">
              {content.logo ? (
                <img src={resolveImg(content.logo)} alt={content.business_name} className="h-24 w-auto object-contain" />
              ) : (
                <span className="font-display uppercase text-3xl">{content.business_name}</span>
              )}
            </div>
            <p className="mt-3 text-neutral-400 max-w-sm">{lang === "es" ? content.tagline_es : content.tagline_en}</p>
          </div>
          <div className="text-neutral-400 text-sm space-y-1 md:text-right">
            <p>{content.address}</p>
            <p>{content.phone} · {content.email}</p>
            <p className="text-[#A8E010]">{content.website}</p>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-neutral-500 uppercase tracking-widest">
          <p>© {new Date().getFullYear()} {content.business_name}. {t("rights", lang)}</p>
          <Link data-testid="admin-link" to="/login" className="hover:text-[#FF5A00] transition-colors">
            {t("admin", lang)}
          </Link>
        </div>
      </div>
    </footer>
  );
};
